(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bd-cookie-preferences"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-cookie-preferences')) customElements.define('bd-cookie-preferences',class extends HTMLElement {
    connectedCallback(){
      this.button=this.querySelector('button');
      this.open=async()=>{
        const status=this.querySelector('[role="status"]');
        status.hidden=true;
        try{
          if(!window.privacyBanner?.showPreferences) throw new Error('unavailable');
          await window.privacyBanner.showPreferences();
        }catch{status.hidden=false;}
      };
      this.button.addEventListener('click',this.open);
    }
    disconnectedCallback(){this.button?.removeEventListener('click',this.open);}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bd-menu-links"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bd-menu-links'))customElements.define('bd-menu-links',class extends HTMLElement{
    connectedCallback(){
      const destinations={'Trade Shows':'trade-shows','Banners & Displays':'banners-displays','Rigid Signs':'rigid-signs','Decals & Magnets':'decals-magnets','Photo & Decor':'photo-decor'};
      const header=document.querySelector('.header-wrapper') || document.querySelector('header');
      if(!header)return;
      this.sync=()=>{
        header.querySelectorAll('.gm-level-0').forEach(item=>{
          const link=item.querySelector(':scope > a');
          const title=link?.getAttribute('title');
          const root=window.Shopify?.routes?.root || '/';
          const url=destinations[title]?`${root}collections/${destinations[title]}`:title==='Shop Per Occasion'?`${root}pages/shop-by-occasion`:null;
          if(!url)return;
          if(link.getAttribute('href')!==url)link.setAttribute('href',url);
          const submenu=item.querySelector(':scope > .gm-submenu');
          if(submenu && title==='Shop Per Occasion' && !submenu.querySelector('.bd-menu-fall')){
            const grid=submenu.querySelector(':scope > .gm-grid');
            if(grid){
              const seasonal=document.createElement('li');
              seasonal.className='gm-item gm-grid-item gmcol-3 gm-has-submenu bd-menu-fall';
              const links=document.createElement('ul');
              links.className='gm-links';
              links.style.setProperty('--columns','1');
              const heading=document.createElement('li');
              heading.className='gm-item gm-heading';
              const anchor=document.createElement('a');
              anchor.className='gm-target js-no-transition';
              anchor.href=root+'collections/fall-thanksgiving';
              anchor.title=this.dataset.fall;
              const label=document.createElement('span');
              label.className='gm-text';
              label.textContent=this.dataset.fall;
              anchor.append(label);heading.append(anchor);links.append(heading);
              seasonal.append(links);grid.append(seasonal);
            }
          }
          if(submenu&&!submenu.querySelector(':scope > .bd-menu-overview:not(.bd-menu-fall)')){
            const overview=document.createElement('a');
            overview.className='bd-menu-overview';overview.href=url;
            overview.textContent=this.dataset.browse.replace('[group]',title);
            submenu.prepend(overview);
          }
        });
      };
      this.observer=new MutationObserver(this.sync);
      this.observer.observe(header,{subtree:true,childList:true});this.sync();
    }
    disconnectedCallback(){this.observer?.disconnect()}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bd-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-mobile-purchase')) {
    customElements.define('bd-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.original = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.info = document.getElementById(`ProductInfo-${this.dataset.section}`);
        if (!this.original || !this.info) return;
        this.button = this.querySelector('[data-bd-buy]');
        this.media = matchMedia('(max-width:749px)');
        this.sync = () => {
          const price = document.getElementById(`price-${this.dataset.section}`);
          const selected = this.info.querySelector('variant-selects, variant-radios');
          this.querySelector('[data-bd-selection]').textContent = selected ? Array.from(selected.querySelectorAll('select,input[type=radio]:checked'), e => e.value).join(' / ') : this.info.querySelector('h1')?.textContent.trim();
          const priceValue = price?.querySelector('.price--on-sale .price__sale .price-item--sale') || price?.querySelector('.price__regular .price-item--regular') || price;
          this.querySelector('[data-bd-price]').textContent = priceValue?.textContent.trim() || '';
          this.button.disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
          const rect = this.original.getBoundingClientRect();
          this.hidden = !this.media.matches || (rect.top < innerHeight && rect.bottom > 0);
        };
        this.onBuy = () => {
          const design = this.info.querySelector('textarea');
          const destination = design || this.original;
          destination.scrollIntoView({block:'center',behavior:'instant'});
          destination.focus({preventScroll:true});
        };
        this.button.addEventListener('click',this.onBuy);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.info,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
        this.intersection = new IntersectionObserver(this.sync);
        this.intersection.observe(this.original);
        this.media.addEventListener('change',this.sync);
        this.info.addEventListener('change',this.sync);
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();this.intersection?.disconnect();
        this.media?.removeEventListener('change',this.sync);
        this.info?.removeEventListener('change',this.sync);
        this.button?.removeEventListener('click',this.onBuy);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bd-page-contents"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-page-contents')) customElements.define('bd-page-contents',class extends HTMLElement {
    connectedCallback(){
      const list=this.querySelector('ul');
      if(list.children.length) return;
      const headings=Array.from(this.parentElement.querySelectorAll('h2'));
      headings.forEach((heading,index)=>{
        if(!heading.textContent.trim()) return;
        if(!heading.id) heading.id=`policy-section-${index+1}`;
        heading.classList.add('bd-policy-anchor');
        const li=document.createElement('li');const a=document.createElement('a');
        a.href=`#${heading.id}`;a.textContent=heading.textContent.trim();li.append(a);list.append(li);
      });
      this.hidden=!list.children.length;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantitypricechange"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event => {
    const button = event.target.closest('.qty-button');
    if (!button) return;
    const input = button.parentElement.querySelector('input');
    if (!input) return;
    const oldValue = Number(input.value) || 0;
    input.value = Math.max(0,oldValue + (button.textContent.trim() === '+' ? 1 : -1));
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });
  } catch(e) { console.error(e); }
})();

})();
